import React, { useState,useEffect } from "react";
import { FaSave } from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import addeventapi from '../api/addeventapi';
import loginapi from '../api/accesstokenrouterapi';
import { FaPlusCircle } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { APISERVERURL } from '../APIServerURL';

import SelectedImages from '../components/SelectedImages'

const EditEventPage = ({ accessToken,setAccessToken, setRefreshFailed }) => {
     const navigate = useNavigate();  
      const { form_id} = useParams();
      
    const [images,setImages]=useState([]);
        const [isLoading,setIsloading]=useState(false);
        
        const [name, setName] = useState("");
        const [description, setDescription] = useState("");
        const [ondate, setOndate] = useState("");
        const [publishInWebsite, setPublishInWebsite] = useState("");


    const [uploadedPhotos,setUploadedPhotos]=useState([]);



    
    const handleAddNew=async (e)=>
        {
           e.preventDefault();
           
           
            let formData = new FormData();    //formdata object
            formData.append("form_id", form_id);
            formData.append("name", name);
            formData.append("description", description);
            formData.append("ondate", ondate);
            formData.append("publishInWebsite", publishInWebsite);
      
            
      
            Object.values(images).forEach(file=>{
              formData.append("images", file);
            });
            const config = {     
                headers: { 'content-type': 'multipart/form-data' }
            }
      
          
           //call api to save the form  

            setIsloading(true);
            try{
            const response= await addeventapi.post('/updateEvent',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
            setIsloading(false);
            if(response.data.status!='OK')
            {
            alert(JSON.stringify(response.data));
            }
            else{
              alert('Event Updated!');
              navigate('/allevents');
            }
            
            }
            catch(err)
            {
                try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);
                //alert(JSON.stringify(x['data']['accessToken']));
                
                const nat=x['data']['accessToken'];
                setAccessToken(nat);
                //console.log(`ne at ${nat}`);
                //console.log(`Second at:${accessToken}`);
                try{       
                    const response= await addeventapi.post('/updateEvent',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                    if(response.data.status!='OK')
                      {
                      alert(JSON.stringify(response.data));
                      }
                      else{
                        alert('Event Updated!');
                        navigate('/allevents');
                      }
                    //navigate('/');
                }
                catch(err)
                {
                    alert('unusual error newposts.js');
                    setIsloading(false);
                    //navigate('/');
                }
                }
                catch(err)
                {
                alert('failed');
                setIsloading(false);
                //setError(JSON.stringify(err));
                //navigate('/');
                }

            }
          }

    function addToImageList(selectedFiles)
    {
        const newImages=[...images,...selectedFiles];
        setImages(newImages);
        console.log(newImages.length);
    }

    const handleGoBack=(e)=>{
        e.preventDefault(); navigate('/allevents');
    }
  
    const setRegistrationForm = (form) => {
      setName(form.name || "");
      setDescription(form.description || []);
      setOndate(form.ondate || "");
      setPublishInWebsite(form.publishInWebsite || "");
      setUploadedPhotos(form.images);
    };

    const loadForm=async ()=>{
      setIsloading(true);
        try{       
          //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
          const response=await addeventapi.post('/getEvent',{form_id},{headers:{'Authorization':`Bearer ${accessToken}`}});  
          setRegistrationForm(response.data.registrationForm);//JSON.stringify(response.data.registrationForm);
          setIsloading(false);
          //alert(JSON.stringify(response.data));
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);            
              const nat=x['data']['accessToken'];
              const lt=x['data']['loginType'];
              //alert(nat);
              setAccessToken(nat);
              setRefreshFailed(false);  
                      
             
                if(lt.toLowerCase()==="admin")
                  {
                        try{       
                          //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                          const response=await addeventapi.post('/getEvent',{form_id},{headers:{'Authorization':`Bearer ${nat}`}});   
                          setRegistrationForm(response.data.registrationForm);//JSON.stringify(response.data.registrationForm);
                          setIsloading(false);
                          //alert(JSON.stringify(response.data));
                      }
                      catch(err)
                      {
                        if( err.response.status===403)
                          {
                            navigate(`/accessdenied`); 
                          }
                        //alert('refresh failed unusual'+JSON.stringify(err));
                        setAccessToken('');
                        setRefreshFailed(true);  
                      }
                    }
              }
              catch(err)
              {
                //alert('dd');
                setAccessToken(''); 
                setRefreshFailed(true);              
              }
          }         
           finally
              {
                //setIsAppLoaded(true);
                //alert('app loaded'+accessToken);
                setIsloading(false);
              }
      }
    
      useEffect(()=>{
        loadForm();
      },[]);

    
      async function deletePhoto(e,img,postId)
      {
        e.preventDefault();
        try{
          const response= await addeventapi.post('/deleteEventPhoto',{form_id:postId,fileName:img},{headers:{'Authorization':`Bearer ${accessToken}`}});      
          await loadForm();
          
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await addeventapi.post('/deleteEventPhoto',{form_id:postId,fileName:img},{headers:{'Authorization':`Bearer ${nat}`}});      
                  await loadForm();
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
      }
      
    return (
        <main className="w-full">
        <div className="flex flex-col items-center w-full">


         <div className="w-full relative py-1">
            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">EDIT EVENT DETAILS</h1>
            <p className='text-center text-xs'>
            </p>
          </div>
        
        <div className="flex flex-col w-[98%] max-w-[1200px]  justify-center items-center bg-gray-100">
            <form className='flex flex-col justify-center items-center' onSubmit={handleAddNew}>

            
            <div className="mt-4 w-[98%] max-w-[600px] ">
  <label>Title</label>
  <input
    type="text"
    value={name}
    onChange={(e) => setName(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>
<div className="mt-4 w-[98%] max-w-[600px]">
  <label>Add a brief description of the event</label>
  <textarea
    value={description}
    onChange={(e) => setDescription(e.target.value)}
    className="border-1 border-b-2 border-blue-500 p-2 w-full bg-transparent resize-none"
    rows={6}
  />
</div>

<div className="mt-4 w-[98%] max-w-[600px]">
  <label>Ondate</label>
  <input
    type="date"
    value={ondate}
    onChange={(e) => setOndate(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>

<div className="mt-4 w-[98%] max-w-[600px]">
  <label>Publish in Website</label>
  <select
    value={publishInWebsite}
    onChange={(e) => setPublishInWebsite(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  >
    <option value="">Please Select</option>
    <option value="YES">YES</option>
    <option value="NO">NO</option>
  </select>
</div>
<div className="mt-4">
  <p className="m-2 w-full text-center">Uploaded Images</p>
  <div className="flex flex-wrap w-full  gap-2 justify-center">
  {uploadedPhotos && uploadedPhotos.length>0 && uploadedPhotos.map((image,index)=>{
        return      <div className='imgThumb' key={index}>
                      <img  src={`${APISERVERURL}/eventimg/${image}`} alt="placeholder" />
                      <span><button className='btn btn-danger' style={{fontSize:'13px', letterSpacing:'1.1px'}} onClick={(e)=>{deletePhoto(e,image,form_id)}}>DELETE</button></span>
                    </div>
       })
    }
    {(!uploadedPhotos || uploadedPhotos.length<=0)&& <p>No photos uploaded</p>
    }

    </div>
</div>
            
            <input className="marginTop w-[98%] max-w-[600px] bg-green-200" type='file' id="fuPhotos" name="uploadedPhotos" multiple
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e)=>{addToImageList(e.target.files)}}
            ></input>
            <SelectedImages
            images={images}
            setImages={setImages}
            >
            </SelectedImages>

            <div className="flex justify-between mt-6 mb-6 w-[98%] max-w-[600px]">
            <button
                onClick={handleGoBack}
                className="bg-gray-500 hover:bg-gray-700 text-white font-semibold py-1 px-6 rounded-2xl shadow-md transition"
            >
                BACK
            </button>
            <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-800 text-white font-semibold py-1 px-6 rounded-2xl shadow-md transition"
            >
                UPDATE
            </button>
            </div>

            </form>
        </div>




        </div>
        </main>
    );
};

export default EditEventPage;
